import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import {Link} from "react-router-dom";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import CircularProgress from '@material-ui/core/CircularProgress';

// icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import BackupIcon from '@material-ui/icons/Backup';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';
import SearchIcon from '@material-ui/icons/Search';

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

// services
import { UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

const useStyles = makeStyles(styles);

export default function ConciliacaoCartao() {
    const { t } = useTranslation();
    const classes = useStyles();

    const session = useContext(SessionContext);

    const [isLoading, setisLoading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
 
    const ReprocessarConciliacao = () => {
        setisLoading(true);
        UsePostApi("ConciliacaoCartao/Conciliar/" + session.franquiaId, "").then(result => {
            setisLoading(false);
            if(result.status !== 200)
            {                       
                showNotification(result.message, 'danger');                
                return false; 
            }

            showNotification(t('conciliation.reprocessing_performed_successfully'), 'success');                
            return false; 
        });
    }

    return (
        <div className="maxContent">                
            {isLoading && 
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div> 
            }
            {notification.show &&
                <div><br/>
                <SnackbarContent
                    message={notification.message}
                    color={notification.color}
                    closeNotification={() => setNotification({show:false})}
                    close
                />
            </div>}         
            <GridContainer>                                                    
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PlaylistAddCheckIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                            {t('conciliation.card_reconciliation')}
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>                                
                                <GridItem xs={12} sm={6} md={6}>
                                    <div style={{textAlign:'center'}}>
                                    <Link to="./ConciliacaoImportarArquivo" >
                                        <div className={classes.bigbutton} style={{marginBottom:'20px'}}                                                                            
                                            >
                                            <BackupIcon className={classes.bigbico}  />
                                            <br/>
                                            <h4> {t('conciliation.import_postings')} </h4>
                                            <span> {t('conciliation.import_whitelist')} </span>
                                        </div>
                                    </Link>
                                    </div>
                                </GridItem>                                                
                                <GridItem xs={12} sm={6} md={6}>
                                <div style={{textAlign:'center'}}>
                                <Link to="./ConciliacaoLancamentoManual" >
                                <div className={classes.bigbutton} style={{marginLeft:'10px'}}                                    
                                    >
                                        <LaunchIcon className={classes.bigbico}  />
                                        <br/>
                                        <h4> {t('conciliation.manual_launch')} </h4>
                                        <span> {t('conciliation.include_manual_registration')} </span>
                                    </div>
                                </Link>
                                </div>
                                </GridItem>  
                                <GridItem xs={12} sm={6} md={6}>
                                <div style={{textAlign:'center'}}> 
                                <Link to="./ConciliacaoPendente" >
                                <div className={classes.bigbutton} style={{marginLeft:'10px'}}
                                    >
                                        <SearchIcon className={classes.bigbico}  />
                                        <br/>
                                        <h4> {t('conciliation.pending_reconciliation')} </h4>
                                        <span> {t('conciliation.Postings_that_were_not_reconciled')} </span>
                                    </div>
                                    </Link>
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                <div style={{textAlign:'center'}}> 
                                <div className={classes.bigbutton} style={{marginLeft:'10px'}}
                                    onClick={() => ReprocessarConciliacao()} >
                                        <RefreshIcon className={classes.bigbico}  />
                                        <br/>
                                        <h4> {t('conciliation.reprocess_conciliation')} </h4>
                                        <span> {t('conciliation.reprocess_non_reconciled_entries')} </span>
                                    </div>
                                    </div>
                                </GridItem>
                            </GridContainer>                          
                        </CardBody>
                    </Card>
                </GridItem>                                                                                                                                          
            </GridContainer>
        </div>
    );
}